import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserDashboardcardsComponent } from './user-dashboardcards/user-dashboardcards.component';

const routes: Routes = [
  {
    path: '',
    children: [{
      path: 'browse',
      component: UserDashboardcardsComponent
    }]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserDashboardRoutingModule { }



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboard-routing.module.ts